const generateMonthCollection = (isNoun = true, limit = 12, capitalize = false, isForGenerateInvoices = false) => {
  const months = [
    isNoun ? (capitalize ? 'Styczeń' : 'styczeń') : (capitalize ? 'Styczeń' : 'styczniu'),
    isNoun ? (capitalize ? 'Luty' : 'luty') : (capitalize ? 'Luty' : 'lutym'),
    isNoun ? (capitalize ? 'Marzec' : 'marzec') : (capitalize ? 'Marzec' : 'marcu'),
    isNoun ? (capitalize ? 'Kwiecień' : 'kwiecień') : (capitalize ? 'Kwiecień' : 'kwietniu'),
    isNoun ? (capitalize ? 'Maj' : 'maj') : (capitalize ? 'Maj' : 'maju'),
    isNoun ? (capitalize ? 'Czerwiec' : 'czerwiec') : (capitalize ? 'Czerwiec' : 'czerwcu'),
    isNoun ? (capitalize ? 'Lipiec' : 'lipiec') : (capitalize ? 'Lipiec' : 'lipcu'),
    isNoun ? (capitalize ? 'Sierpień' : 'sierpień') : (capitalize ? 'Sierpień' : 'sierpniu'),
    isNoun ? (capitalize ? 'Wrzesień' : 'wrzesień') : (capitalize ? 'Wrzesień' : 'wrześniu'),
    isNoun ? (capitalize ? 'Październik' : 'październik') : (capitalize ? 'Październik' : 'październiku'),
    isNoun ? (capitalize ? 'Listopad' : 'listopad') : (capitalize ? 'Listopad' : 'listopadzie'),
    isNoun ? (capitalize ? 'Grudzień' : 'grudzień') : (capitalize ? 'Grudzień' : 'grudniu')
  ];

  const result = months.slice(0, limit).map((month, index) => {
    const adjustedIndex = (index + 2) % 12; // Przesunięcie o 2 miesiące do przodu
    const invoiceMonth = months[adjustedIndex].toLowerCase();
    const title = isForGenerateInvoices
      ? (
        <span>
          {month} (faktury <strong style={{ fontWeight: 'bold' }}>{invoiceMonth}</strong>)
        </span>
      )
      : month;
    return {
      id: (index + 1).toString(),
      title: title
    };
  });

  return result;
};

const generateYearCollection = (startYear, endYear) => {
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

  const result = years.map((year) => {
    return {
      id: year.toString(),
      title: year.toString()
    };
  });

  return result;
};

const range = [
  '1', '2', '3', '4', '5', '6', '8', '12'
]

const rangeCollection = range.map(item => ({
  id: item,
  title: item
}));

const activityLogRanges = [
  { value: '1', label: '1 dzień' },
  { value: '3', label: '3 dni' },
  { value: '7', label: '7 dni (1 tydzień)' },
  { value: '10', label: '10 dni (domyślnie)' },
  { value: '14', label: '14 dni (2 tygodnie)' },
  { value: '21', label: '21 dni (3 tygodnie)' },
  { value: '30', label: '30 dni (1 miesiąc)' },
  { value: '60', label: '60 dni (2 miesiące)' },
  { value: '90', label: '90 dni (3 miesiące)' },
  { value: '120', label: '120 dni (maksymalnie)' }
];

const activityLogRangeCollection = activityLogRanges.map(item => ({
  key: item.value,
  value: item.label,
  id: item.value,
  title: item.label
}));

const packageNumber = [
  '2', '3', '4'
]

const packageCollection = packageNumber.map(item => ({
  key: item,
  value: item
}));

export const getMonthCollection = (limit) => generateMonthCollection(true, limit, true);
export const getYearCollection = (startYear, endYear) => generateYearCollection(startYear, endYear);
export const getRangeCollection = () => rangeCollection;
export const getActivityLogRangeCollection = () => activityLogRangeCollection;
export const getPackageCollection = () => packageCollection;
export const getMonthCollectionForGenerateInvoices = (limit) => generateMonthCollection(true, limit, true, true);
export const getMonthCollectionForInvoice = () => generateMonthCollection(false);

export const getMonthNameById = (id) => {
  const month = generateMonthCollection(true).find(month => month.id === id);
  return month ? month.title : 'Nieznany';
};

export const getMonthNameByIdForInvoice = (id) => {
  const month = generateMonthCollection(false).find(month => month.id === id);
  return month ? month.title : 'Nieznany';
};

const UserRole = [
  'ACCOUNTANT',
  'CHIEF_ACCOUNTANT',
  'SUPERVISOR',
  'TRADER',
  'ADMIN',
  'ACCOUNT_MANAGER',
  'MANAGER',
  'ADMIN_SUPERVISOR',
  'SUPERVISOR_ACCOUNTANT',
  'EXTERNAL_IT',
  'NO_PERMISSIONS'
];

export const roleTranslations = {
  ACCOUNTANT: 'Księgowy',
  CHIEF_ACCOUNTANT: 'Księgowy-Główny Księgowy',
  SUPERVISOR_ACCOUNTANT: 'Księgowy-Superwizor',
  SUPERVISOR: 'Superwizor',
  TRADER: 'Handlowiec',
  ADMIN: 'Administrator',
  ACCOUNT_MANAGER: 'Opiekun Klienta',
  MANAGER: 'Kierownik',
  ADMIN_SUPERVISOR: 'Admin-Superwizor',
  EXTERNAL_IT: 'Zewnętrzna firma IT',
  NO_PERMISSIONS: 'Brak uprawnień'
};

const roleCollection = UserRole.map(role => ({
  key: role,
  value: roleTranslations[role] || role // Użyj tłumaczenia lub angielskiej nazwy, jeśli brak tłumaczenia
}));

export const getRoleCollection = () => roleCollection;


const alphabet = ['Wszyscy klienci',
  'A', 'Ą', 'B', 'C', 'Ć', 'D', 'E', 'Ę', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
  'Ł', 'M', 'N', 'Ń', 'O', 'Ó', 'P', 'R', 'S', 'Ś', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'Ź', 'Ż'
];

const numbers = Array.from({ length: 10 }, (_, index) => index.toString());

const alphabetAndNumbers = [...alphabet, ...numbers];

const letterCollection = alphabetAndNumbers.map(item => ({
  id: item,
  title: item
}));

export const getLetterCollection = () => letterCollection;

export const logActionType = {
  LOGIN: "Logowanie",
  LOGOUT: "Wylogowanie",
  CLIENT_CARD_EDIT: "Edycja karty klienta: ",
  ACCOUNTANT_CARD_EDIT: "Edycja karty księgowej: ",
  ADD_NEW_ACCOUNTANT: "Dodanie nowego księgowego: ",
  ADD_NEW_CLIENT: "Dodanie nowego klienta: ",
  STATEMENT_EDIT: "Edycja zestawiena księgowej: ",
  DEBT_STATUS_ROW_EDIT: "Edycja tabeli: status windykacji ",
  CLIENTS_WAITING_FOR_START_ROW_EDIT: "Edycja tabeli: klienci oczekujący na start ",
  CLIENTS_WAITING_FOR_ACCOUNTANT_ROW_EDIT: "Edycja tabeli: klienci oczekujący na zmianę księgowej ",
  CLIENTS_ENDED_COOPERATION: "Edycja tabeli: kończenie współpracy ",
  ARCHIVE_CLIENTS_WAITING_FOR_START_ROW: "Edycja tabeli: klienci oczekujący na start, zarchiwizowano wiersz klienta: ",
  ARCHIVE_CLIENTS_WAITING_FOR_ACCOUNTANT_ROW_EDIT: "Edycja tabeli: klienci oczekujący na zmianę księgowej, zarchiwizowano wiersz klienta: ",
  GENERATE_INVOICES_END: "Ukończono generowanie faktur za miesiąc ",
  GENERATE_INVOICES_START: "Rozpoczęto generowanie faktur za miesiąc ",
  GENERATE_INVOICES_END_STATEMENTS: "Ukończono generowanie faktury za sprawozdanie finansowe ",
  GENERATE_INVOICES_START_STATEMENTS: "Rozpoczęto generowanie faktury za sprawozdanie finansowe ",
  CONFIRM_PAYMENT: "Potwierdzenie realizacji przelewu dla ",
  UNLOCK_STATEMENT: "Odblokowanie do edycji zestawienia księgowego: ",
  APPROVE_FOR_PAYMENT: "Zatwierdzenie do wypłaty zestawienia księgowego: ",
  SAVE_AND_SEND_STATEMENT: "Zakończenie i wysłanie zestawienie księgowego: ",
  UNLOCK_INVOICE: "Odblokowanie procesu wgraj faktury dla księgowego: ",
  ADD_NEW_USER: "Utworzenie użytkownika: ",
  EDIT_USER_ROLE: "Edycja uprawnień użytkownika: ",
  ADD_NEW_ACCOUNTANT_TARIFF: "Dodanie nowych stawek dla księgowych: ",
  EDIT_ACCOUNTANT_TARIFF: "Edycja stawek księgowych: ",
  ADD_NEW_CLIENT_TARIFF: "Dodanie nowego cennika klientów: ",
  EDIT_CLIENT_TARIFF: "Edycja cennika klientów: ",
  APPROVE_ADDITIONAL_WORK: "Zatwierdzono prace dodatkowe dla ",
  ADDITIONAL_WORK_PAID: "Zapłacono za prace dodatkowe dla ",
  ARCHIVE_CLIENTS_ENDED_COOP_ROW: "Edycja tabeli: kończenie współpracy, zarchiwizowano wiersz klienta: ",
  APPROVE_DISCOUNT: "Zatwierdzono rabat dla firmy ",
  APPROVE_ADDITIONAL_WORK_AMOUNT: "Wprowadzono kwotę zatwierdzoną do wypłaty dla: ",
  CLIENTS_FINANCIAL_STATEMENT_ROW_EDIT: "Edycja tabeli: sprawozdania finansowe ",
  EDIT_SCANYE_ACCESS: "Edycja dostępu do skanów ",
  REVOKE_SCANYE_ACCESS: "Usunięcie dostępu do skanów ",
  CLEAR_CACHE: "Wyczyszczono cache aplikacji",
  SALARY_BLOCK_ADD: "Nałożenie blokady wynagrodzenia: ",
  SALARY_BLOCK_RELEASE: "Zdjęcie blokady wynagrodzenia: ",
  SALARY_BLOCK_CORRECTION_UPLOAD: "Wgranie korekty do blokady wynagrodzenia: ",
  ADDITIONAL_WORK_CORRECTION_UPLOAD: "Wgranie korekty do prac dodatkowych: ",
  FINANCIAL_STATEMENT_CORRECTION_REQUEST: "Żądanie korekty faktury do sprawozdania: ",
  FINANCIAL_STATEMENT_CORRECTION_UPLOAD: "Wgranie korekty faktury do sprawozdania: ",
};

export const fileAssignmentId = {
  ACCOUNTING_SETTLEMENT: 1,
  ACCOUNTANT_CARD: 11,
  CLIENT_FINANCIAL_STATEMENT: 21
};

export const localeTextPL = {
  filterOoo: "Filtr...",
  equals: "Równe",
  notEqual: "Różne",
  lessThan: "Mniejsze niż",
  greaterThan: "Większe niż",
  lessThanOrEqual: "Mniejsze lub równe",
  greaterThanOrEqual: "Większe lub równe",
  inRange: "W zakresie",
  contains: "Zawiera",
  notContains: "Nie zawiera",
  startsWith: "Zaczyna się od",
  endsWith: "Kończy się na",
  blank: "Puste",
  notBlank: "Nie puste",
  applyFilter: "Zastosuj",
  resetFilter: "Resetuj",
  clearFilter: "Wyczyść",
  andCondition: "I",
  orCondition: "LUB",
  dateFormatOoo: "yyyy-MM-dd", // Format daty
};

export const allLegalForms = [
  { id: 0, title: 'Wszystkie' },
  { id: 1, title: 'Jednoosobowa działalność gospodarcza' },
  { id: 11, title: 'Spółka cywilna' },
  { id: 21, title: 'Spółka jawna' },
  { id: 31, title: 'Spółka partnerska' },
  { id: 41, title: 'Spółka komandytowa' },
  { id: 51, title: 'Spółka komandytowo-akcyjna' },
  { id: 61, title: 'Spółka z ograniczoną odpowiedzialnością' },
  { id: 71, title: 'Spółka akcyjna' },
  { id: 81, title: 'Stowarzyszenie' },
  { id: 91, title: 'Fundacja' },
  { id: 101, title: 'Spółdzielnia' },
  { id: 111, title: 'Prosta Spółka Akcyjna' },
];

export const clientCardInitialValues = {
  id: null,
  companyName: '',
  companyWorkingName: '',
  nip: '',
  isActive: true,
  cooperationStatus: 'ACTIVE',
  fakturowniaPayableFrom: '',
  statusVat: '',
  isCompanyEstablishedBy7PM: '',
  isContinuationOfJDG: '',
  isTransferOfAccounting: '',
  isContract: '',
  isGenerateInvoice: '',
  isOptima: '',
  isInsert: '',
  legalFormId: '',
  obtainedByContactId: '',
  accountManagerId: '',
  dateOfEntryInKRS: '',
  firstFiscalYear: '',
  uplSupervisor: '',
  additionalContact: '',
  isPaidInAdvance: '',
  paidInAdvanceTo: '',
  fakturowniaPrice: '',
  clientPanelUrl: '',
  cooperationHistoryDTOs: [
    {
      id: null,
      cooperationStartDate: '',
      cooperationEndDate: '',
      suspensionStartDate: '',
      suspensionEndDate: '',
      suspended: false,
      contactId: '',
      reasonForTerminatingCooperationId: ''
    }
  ],
  tradersComments: '',
  businessDesc: '',
  accountantDTOs: [],
  currentSupervisorName: '',
  phones: [
    {
      id: null,
      number: '',
      contactId: '',
      tphoneTypeId: ''
    }
  ],
  emails: [
    {
      id: null,
      emailAddress: '',
      contactId: '',
      temailTypeId: ''
    }
  ],
  clientContactDTOs: [
    {
      id: null,
      name: '',
      emails: [
        {
          id: null,
          emailAddress: '',
          contactId: '',
          temailTypeId: 21
        }
      ],
      phones: [
        {
          id: null,
          number: '',
          contactId: '',
          tphoneTypeId: 21
        }
      ]
    }
  ],
  addressEntity: {
    id: null,
    discontinueDate: null,
    street: '',
    postalCode: '',
    city: ''
  },
  clientTariffDTOs: [{
    id: null,
    clientId: null,
    startDate: '',
    endDate: '',
    tclientTariffId: '',
  }],
  clientPackageDTOs: [{
    id: null,
    clientId: null,
    startDate: '',
    endDate: '',
    tpackageTypeId: '',
  }],
  notes: []
}

export const pathNameMap = {
  "/ClientsList": "Lista klientów",
  "/MonthlyStatement": "Zestawienie miesięczne",
  "/ExcelToSql": "Import faktur z Excela",
  "/GenerateInvoices": "Kasa",
  "/AdditionalCosts": "Koszty dodatkowe",
  "/AccountantsList": "Lista księgowych",
  "/ApproveStatements": "Zatwierdzanie zestawień",
  "/StartAccounting": "Zarządzanie klientami",
  "/Overview": "Panel zarządzania",
  "/DebtCollection": "Windykacja",
  "/Settings": "Ustawienia",
  "/FinancialStatements": "Sprawozdania finansowe",
  "/Imports": "Importowanie danych",
  "/ClientSurvey": "Ankiety klientów",
  "/SalaryBlocks": "Blokady wynagrodzeń",
};

// NOWE: dynamiczny tytuł wg roli
export const getPathTitleForRoles = (path, roles = []) => {
  let title = pathNameMap[path] || "Nieznana podstrona";
  if (
    path === "/GenerateInvoices" &&
    (roles.includes("ACCOUNTANT") || roles.includes("SUPERVISOR_ACCOUNTANT") || roles.includes("CHIEF_ACCOUNTANT"))
  ) {
    return "Status zestawienia";
  }
  if (
    path === "/AdditionalCosts" &&
    (roles.includes("ACCOUNTANT") || roles.includes("SUPERVISOR_ACCOUNTANT") || roles.includes("CHIEF_ACCOUNTANT"))
  ) {
    return "Prace dodatkowe";
  }
  return title;
};

export const statusMap = {
  ACTIVE: "Aktywny",
  SUSPENDED: "Zawieszony",
  ENDED: "Zak. współpraca",
  FUTURE_START: "Oczekuje na start",
  FUTURE_END: "Wygasająca",
  FUTURE_SUSPENSION: "Oczekuje na zawieszenie",
  FUTURE_UNDO_SUSPENSION: "Oczekuje na odwieszenie"
};

export const getVatStatus = () => ([
  { key: 'CZYNNY', value: 'Czynny' },
  { key: 'ZWOLNIONY', value: 'Zwolniony' },
  { key: 'NIEZAREJESTROWANY', value: 'Niezarejestrowany' }
]);

export const getToDoStatus = () => ([
  { key: 'DOING_PAY_LATER', value: 'Robimy - płatne później' },
  { key: 'DOING_PREPAID', value: 'Robimy - opłacono z góry' },
  { key: 'DOING_WAITING_FOR_PROFORMA', value: 'Robimy - czeka na proformę' },
  { key: 'NOT_DOING', value: 'Nie robimy' },
  { key: 'TO_BE_DEFINED', value: 'Do ustalenia' },
  { key: 'WAITING_FOR_PAYMENT', value: 'Czekamy na wpłatę' }
]);

export const toDoStatusEnumMap = {
  DOING_PAY_LATER: 'Robimy - płatne później',
  DOING_PREPAID: 'Robimy - opłacono z góry',
  NOT_DOING: 'Nie robimy',
  TO_BE_DEFINED: 'Do ustalenia (nie wysyłaj!)',
  WAITING_FOR_PAYMENT: 'Czekamy na wpłatę (nie wysyłaj!)',
  DOING_WAITING_FOR_PROFORMA: 'Robimy - czekamy na proformę',
};

// Statusy, dla których wyświetlamy ostrzeżenie "(nie wysyłaj!)" pogrubioną czcionką
export const toDoStatusWarning = new Set(['TO_BE_DEFINED', 'WAITING_FOR_PAYMENT']);
